import { Card, CircularProgress, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useGetProjectNeedSlotsQuery, useGetProjectQuery, useGetProjectWhatNeededQuery } from "../../../../../../api/projects";
import { NotFound } from "../../../../../ui-kit/NotFound";
import { NeedSlotCard } from "../../NeedSlotCard";

export const WhatNeeded = () => {
    const { slug } = useParams<{ slug: string }>()
    const { data: project, isLoading: isProjectLoading } = useGetProjectQuery(slug ?? "", { skip: !slug })
    const projectId = project?.id
    const {
        data,
        isLoading,
        isError,
    } = useGetProjectWhatNeededQuery(
        { projectId: projectId ?? 0 },
        { skip: !projectId }
    )
    const {
        data: slots = [],
        isLoading: isSlotsLoading,
        isError: isSlotsError,
    } = useGetProjectNeedSlotsQuery(
        { projectId: projectId ?? 0 },
        { skip: !projectId }
    )

    if (isProjectLoading || isLoading || isSlotsLoading) {
        return (
            <Stack alignItems="center" justifyContent="center" height="100%">
                <CircularProgress />
            </Stack>
        )
    }

    if (isError || isSlotsError) return <NotFound text="Не удалось загрузить данные" />

    const list = data?.whatNeeded ?? []
    const structuredList = slots.filter((slot) => slot.kind === 'resource' && slot.status === 'open')
    if (!structuredList.length && !list.length) return <NotFound text="Данные не заполнены" />

    return (
        <Stack direction="column" gap={{ xs: 2.5, sm: 2 }}>
            {structuredList.map((slot) => (
                <NeedSlotCard key={slot.id} slot={slot} />
            ))}
            {list.map((item, index) => (
                <Card variant="primaryAdaptiveCard" sx={{ overflowWrap: 'anywhere' }} key={`${item.title}-${index}`}>
                    <Typography 
                        variant="black-16-semiBold" 
                        component="div"
                        mb={{ xs: 0.5, sm: 1}}
                    >
                        {item.title}
                    </Typography>
                    <Typography variant="body1">{item.description}</Typography>
                </Card>
            ))}
        </Stack>
    )
};
